import { render, staticRenderFns } from "./VisualCards.vue?vue&type=template&id=830f0eec&scoped=true&"
import script from "./VisualCards.vue?vue&type=script&lang=js&"
export * from "./VisualCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830f0eec",
  null
  
)

export default component.exports